export default {

    RadioButtonPfSvg: function() {

        return `<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"22\" viewBox=\"0 0 22 22\">\n" +
                    "<defs>\n" +
                    "<clipPath id=\"clip-Radio_Button_Checked_1\">\n" +
                    "<rect width=\"22\" height=\"22\"/>\n" +
                    "</clipPath>\n" +
                    "</defs>
                    "<g id=\"Radio_Button_Checked_1\" data-name=\"Radio_Button_Checked – 1\" clip-path=\"url(#clip-Radio_Button_Checked_1)\">\n" +
                    "<rect width=\"22\" height=\"22\" fill=\"rgba(81,91,96,0)\"/>\n" +
                    "<g id=\"Group_13314\" data-name=\"Group 13314">
                    "<path id=\"Path_47\"  data-name=\"Path 47\" d=\"M0,0H24V24H0Z\" opacity=\"0\"/>\n" +
                    "<path id=\"Path_48\" class="svg-primary-color" data-name=\"Path 48\" d=\"M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Z\"   '/>\n" +
                    "</g>
                    "<path id=\"Path_52\" class="svg-on-primary-color" data-name=\"Path 52\" d=\"M10,17,5,12l1.41-1.41L10,14.17l7.59-7.59L19,8Z\" />\n" +
                    "</g>\n" +
                    "</svg>`
    }
};





// WEBPACK FOOTER //
// ./src/common/plugins/svg/RadioButtonPfPlugin.js